import moment from "moment";
export function hebrewFormatDate(orderDate) {
  const hebrewMonths = [
    "ינו",
    "פבר",
    "מרץ",
    "אפר",
    "מאי",
    "יונ",
    "יול",
    "אוג",
    "ספט",
    "אוק",
    "נוב",
    "דצמ",
  ];

  const date = new Date(orderDate);

  const day = date.getDate();

  const monthIndex = date.getMonth();

  const year = date.getFullYear();

  const dayName = date.toLocaleString("he-IL", {
    weekday: "narrow",
  });

  return `יום ${dayName} ${day} ב${hebrewMonths[monthIndex]} ${year}`;
}

export function TodayFormat() {
  const date = new Date();
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const formattedDate = `${year}-${month}-${day}T00:00:00+02:00`;
  return formattedDate;
}
export function dateToDisplay(date) {
  return moment(date).format("DD-MM-YY");
}
export function isDateAfterToday(date) {
  return moment(date).isAfter(moment().startOf("day"));
}

export function formatToInputDate(taskdate) {
  let date = new Date(taskdate);

  if (isNaN(date)) {
    console.log("Invalid date string");
    return;
  }

  // Format the date as yyyy-MM-dd
  let formatted =
    date.getFullYear() +
    "-" +
    ("0" + (date.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + date.getDate()).slice(-2);

  return formatted;
}

export function formatDateToPriority(taskdate) {
  const formattedDateString = `${formatToInputDate(taskdate)}T00:00:00+02:00`;

  return formattedDateString;
}
